import { render, staticRenderFns } from "./answering-rules.vue?vue&type=template&id=5aad9032&scoped=true"
import script from "./answering-rules.vue?vue&type=script&setup=true&lang=ts"
export * from "./answering-rules.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./answering-rules.vue?vue&type=style&index=0&id=5aad9032&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aad9032",
  null
  
)

export default component.exports